export enum StackTaskType {
  Job = "Job",
  Workflow = "Workflow",
  ManualUserTask = "ManualUserTask",
}
